import Vue from 'vue'
import store from './store.ts'
import Cookies from 'js-cookie'
import FeatureBodyApp from './FeatureBodyApp.vue'
import i18n from './lang/i18n'
import GtmHelper from "@/components/GtmHelper.vue";
import {installGtm} from "@injoi-utils/vue2-gtm";


Vue.config.productionTip = false

installGtm(GtmHelper.commonDataLayer);
new Vue({
  store,
  i18n,
  async mounted() {
    const lang = Cookies.get('lang');
    await this.$store.dispatch('setIsBsi');
    await this.$store.dispatch('getDisplayData', lang);
  },
  render: h => h(FeatureBodyApp),
}).$mount('#feature-body')


